import { BrandListItem } from '@shared/types';
import React from 'react';
import * as Styled from './BrandItem.style';

type BrandItemProps = {
  brand: BrandListItem;
  /** Show compact view of the brand item */
  isCompact?: boolean;
};

const BrandItem = ({ brand: { brand, companyUrl, integrationsLogo, url }, isCompact }: BrandItemProps) => {
  return (
    <Styled.BrandItem isCompact={isCompact} tabIndex={0} rel="noopener noreferrer" href={companyUrl} target="_blank">
      <Styled.BrandItemLogo
        className="brand-logo"
        // Fallback to brand URL if integrationsLogo is not provided (see Nibe Flow case)
        src={integrationsLogo ?? url}
        alt={brand}
        height="70"
        width="70"
      />
    </Styled.BrandItem>
  );
};

export default React.memo(BrandItem);
